export default {"src":"/_next/static/media/collaborator.d9040e36.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};